import { SLOT_NAMES, callingSlotProblems } from "@components/scheduling/settings/settingsValidation";

const timeClass =
  "border border-gray-300 rounded-lg px-2 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

const LABELS = { morning: "Morning", afternoon: "Afternoon", evening: "Evening" };

/**
 * The three parts of the day a follow-up may be tried in. Each follow-up
 * tries a different slot than the one before it, so a patient who never
 * answers in the morning still gets an evening call before the schedule
 * gives up.
 *
 * The server validates and normalises these too; the messages here are so
 * the clinic sees the problem before it saves, not after.
 */
export default function CallingSlotsEditor({ slots, onChange }) {
  const problems = callingSlotProblems(slots);

  const update = (name, index, value) => {
    const pair = slots?.[name] || ["", ""];
    const next = index === 0 ? [value, pair[1]] : [pair[0], value];
    onChange({ ...slots, [name]: next });
  };

  return (
    <div className="space-y-3">
      {SLOT_NAMES.map((name) => {
        const [start, end] = slots?.[name] || ["", ""];
        return (
          <div key={name}>
            <div className="flex items-center gap-2">
              <span className="w-20 text-sm text-gray-700">{LABELS[name]}</span>
              <input type="time" className={timeClass} value={start}
                     aria-label={`${LABELS[name]} start`}
                     onChange={(e) => update(name, 0, e.target.value)} />
              <span className="text-sm text-gray-500">to</span>
              <input type="time" className={timeClass} value={end}
                     aria-label={`${LABELS[name]} end`}
                     onChange={(e) => update(name, 1, e.target.value)} />
            </div>
            {problems[name] && (
              <p className="mt-1 text-xs text-red-600">{problems[name]}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}
